<script lang="ts">
  const currentYear = new Date().getFullYear();
</script>

<footer class="footer">
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-section">
        <h3>🌿 Grn Haus Games</h3>
        <p>Eco-friendly gaming for World Cup 2026! Green, sustainable, and fun.</p>
        <div class="social-links">
          <a href="#" aria-label="Facebook">📘</a>
          <a href="#" aria-label="Twitter">🐦</a>
          <a href="#" aria-label="Instagram">📷</a>
          <a href="#" aria-label="YouTube">📺</a>
        </div>
      </div>
      
      <div class="footer-section">
        <h4>Quick Links</h4>
        <ul>
          <li><a href="#games">Games</a></li>
          <li><a href="#wheel-section">Spin to Play</a></li>
          <li><a href="#leaderboard">Leaderboard</a></li>
          <li><a href="#about">About</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Legal</h4>
        <ul>
          <li><a href="/privacy">Privacy Policy</a></li>
          <li><a href="/terms">Terms of Service</a></li>
          <li><a href="/disclaimer">Disclaimer</a></li>
          <li><a href="/cookies">Cookie Policy</a></li>
        </ul>
      </div>
      
      <div class="footer-section">
        <h4>Contact</h4>
        <ul>
          <li>📧 support@grnhaus.info</li>
          <li>💬 Live Chat Available</li>
          <li>⏰ 24/7 Support</li>
        </ul>
      </div>
    </div>
    
    <div class="footer-bottom">
      <p>&copy; {currentYear} GRN HAUS GAMES. - All rights reserved.</p>
      <a href="https://grnhouse.info" class="grn-haus-link" target="_blank" rel="noopener noreferrer">GRN HAUS</a>
      <p class="disclaimer">🌍 Eco-Friendly Gaming • ♻️ Recycle Friendly • 🏆 World Cup 2026 Ready</p>
    </div>
  </div>
</footer>

<style>
  .footer {
    background: linear-gradient(135deg, #1a472a 0%, #2d5016 100%);
    color: white;
    padding: 60px 20px 30px;
    margin-top: 60px;
  }
  
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 40px;
  }
  
  .footer-section h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
    color: #2ecc71;
  }
  
  .footer-section h4 {
    font-size: 1.2rem;
    margin-bottom: 15px;
    color: #2ecc71;
  }
  
  .footer-section p {
    line-height: 1.8;
    opacity: 0.9;
  }
  
  .footer-section ul {
    list-style: none;
    padding: 0;
  }
  
  .footer-section ul li {
    margin-bottom: 10px;
  }
  
  .footer-section a {
    color: white;
    text-decoration: none;
    opacity: 0.8;
    transition: all 0.3s ease;
  }
  
  .footer-section a:hover {
    opacity: 1;
    color: #2ecc71;
    padding-left: 5px;
    text-shadow: 0 0 10px rgba(46, 204, 113, 0.5);
  }
  
  .social-links {
    display: flex;
    gap: 15px;
    margin-top: 20px;
  }
  
  .social-links a {
    font-size: 1.8rem;
    transition: transform 0.3s ease;
  }
  
  .social-links a:hover {
    transform: scale(1.2);
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(46, 204, 113, 0.3);
    padding-top: 30px;
    text-align: center;
  }
  
  .footer-bottom p {
    margin-bottom: 10px;
    opacity: 0.8;
  }
  
  .grn-haus-link {
    display: inline-block;
    margin: 10px 0;
    padding: 8px 20px;
    background: linear-gradient(45deg, #2ecc71, #27ae60);
    border-radius: 20px;
    font-weight: 700;
    font-size: 1.1rem;
    transition: all 0.3s ease;
  }
  
  .grn-haus-link:hover {
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(46, 204, 113, 0.5);
  }
  
  .disclaimer {
    font-size: 0.85rem;
    color: #a8e6cf;
    margin-top: 15px;
  }
  
  @media (max-width: 768px) {
    .footer {
      padding: 40px 15px 20px;
    }
    
    .footer-content {
      gap: 30px;
    }
  }
</style>
